import { getUrlParameter } from '@internal_modules_self/ad-conf/lib/index';
import { v1 } from 'uuid';
import sha1 from 'sha1';

const ua = window.navigator.userAgent;
export const isWx = /MicroMessenger/gi.test(ua);

export const authJump = (url, appId) => {
  const appid = getUrlParameter('appid') || appId;
  if (!appid) return url;
  url = window.encodeURIComponent(url);
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
};
// 开启快照的授权方式
export const authJumpOfKz = (url, appId) => {
  const appid = getUrlParameter('appid') || appId;
  if (!appid) return url;
  url = window.encodeURIComponent(url);
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
};

export const baseAuthJump = (url, appId) => {
  const appid = getUrlParameter('appid') || appId;
  if (!appid) return url;
  url = window.encodeURIComponent(url);
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
};

// 加密secret 用于新系统线索类小程序 hashid
export const encryptSecret = () => {
  const secret = 'wl1tn6xr5ua9xhsbjgcikeobl6pnz6ri';
  const CurTime = Date.parse(new Date()) / 1000;
  const Nonce = v1();
  const CheckSum = sha1(secret + Nonce + CurTime);
  return {
    CurTime,
    Nonce,
    CheckSum
  };
};

// 复制到粘贴板
export async function copyTextToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const textArea = document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;

    textArea.style.width = '2em';
    textArea.style.height = '2em';

    textArea.style.padding = 0;

    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    textArea.style.background = 'transparent';

    textArea.value = text;

    document.body.appendChild(textArea);

    textArea.select();

    let success = false;
    try {
      success = document.execCommand('copy');
    } catch (err) {
      console.error(err);
    }

    document.body.removeChild(textArea);
    return success;
  }
}

// 节流函数
export function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 300);
  var last, timer;
  return function () {
    var context = scope || this;
    var now = +new Date(),
      args = arguments;
    if (last && now < last + threshhold) {
      // 如果时间间隔小于设定的节流时间，则清除定时器并重新设定
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      // 如果时间间隔大于或等于设定的节流时间，则直接执行函数
      last = now;
      fn.apply(context, args);
    }
  };
}

// 防抖函数
export function debounce(fn, delay = 300) {
  let timer = null;
  return function () {
    let context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

export function delQuerry(keys = '', href) {
  const urlObj = new URL(window.location.href || href);
  if (!keys) return urlObj.href;

  let keysArr = keys
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item);
  keysArr.forEach((key) => {
    urlObj.searchParams.delete(key);
  });
  // 如果没有搜索参数，则返回不包含查询字符串的URL
  if (!urlObj.search) {
    return urlObj.origin + urlObj.pathname;
  }
  // 如果有搜索参数，返回完整的URL
  return urlObj.href;
}
